import React,{Suspense} from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Beforeunload } from "react-beforeunload";
import GlobalApi from "./Global";
import Colors from "./Global/colors";
import ProductSansRegular from "./Fonts/Product Sans Regular.ttf";
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core/styles";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Redux/Store/store";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import Spinner from "./Global/Spinner";
import './i18n';

// import RalewayWoff2 from './fonts/Raleway-Regular.woff2';

const raleway = {
  fontFamily: "Raleway",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 400,
  src: `
    local('ProductSans'),
    local('ProductSansRegular'),
    url(${ProductSansRegular}) format('woff2')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

const queryClient = new QueryClient();

// const theme = createMuiTheme({
//   typography: {
//     fontFamily: 'ProductSans, Arial',
//     fontWeight: "bold",
//   },
//   overrides: {
//     MuiCssBaseline: {
//       '@global': {
//         '@font-face': [raleway],
//       },
//     },
//   },
// });
const theme = createMuiTheme({
  typography: {
    fontFamily: ["ProductSans"].join(","),
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        position: "relative",
        "& $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
        "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
          borderColor: "#043077",
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderColor: "rgba(0, 0, 0, 0.23)",
          },
        },
        "&$focused $notchedOutline": {
          borderColor: "#043077",
          borderWidth: 2,
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#4A90E2",
        },
      },
    },
    
    MuiTooltip: {
      tooltip: {
        color: Colors.globalColor8,
        backgroundColor: Colors.globalColor9,
      },
    },
  },
});

ReactDOM.render(
  // <Beforeunload
  //   onBeforeunload={async (e) => {
  //     let localstorage = localStorage.getItem("UserData");
  //     let data = JSON.parse(localstorage);
  //     if (data) {
  //       fetch(GlobalApi + "/DeviceRecord/delete_device_record", {
  //         method: "post",
  //         headers: new Headers({
  //           Authorization: "Bearer " + data.token,
  //           "Content-Type": "application/json",
  //         }),
  //         body: JSON.stringify({
  //           device_record_id: data.device_id,
  //         }),
  //       })
  //         .then((res) => res.json())
  //         .then(async (resJson) => {
  //           console.log("ok")
  //           localStorage.removeItem("UserData");
  //         })
  //         .catch(console.log);
  //     }
  //     return "are you sure?";
  //   }}
  // >

  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Suspense fallback={<Spinner/>}>
          <App />
          </Suspense>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </PersistGate>
    </QueryClientProvider>
  </Provider>,

  // </Beforeunload>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


